import { Loader } from 'lucide-react';
import React from 'react';

/**
 * A loading spinner component for suspense fallback.
 * @returns A React element showing a loading indicator.
 */
export const Loading: React.FC = () => (
  <div className="w-full h-full flex items-center justify-center">
    <Loader className="animate-spin text-white" size={24} />
  </div>
); 